import { render, staticRenderFns } from "./configComp.vue?vue&type=template&id=6620e1d8&scoped=true&"
import script from "./configComp.vue?vue&type=script&setup=true&lang=js&"
export * from "./configComp.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./configComp.vue?vue&type=style&index=0&id=6620e1d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6620e1d8",
  null
  
)

export default component.exports